const API_URL = process.env.REACT_APP_API_URL;
export const PROXY_PORT = 3001;

export default API_URL;

// Contact information
export const COPYRIGHT_INFO =
  "©2026 Designed and developed by { David Seibold }";
export const CONTACT_EMAIL = "d.seibold@icloud.com";
export const CONTACT_NAME = "David Seibold";
export const CONTACT_PHONE = "+1(818)274-9823";

// Social media
export const TWITTER_X_URL = "https://x.com/Davey_Rockets";
export const LINKEDIN_URL = "https://www.linkedin.com/in/davidseibold/";
export const GITHUB_URL = "https://github.com/PenneconDavid";
